document.addEventListener("DOMContentLoaded", function() {
    // Select the clickable element(s)
    var clickable_elements = document.querySelectorAll(".CTAT");
    if(clickable_elements){
        clickable_elements.forEach(function(element) {
            element.addEventListener("mousedown", async function(event) {
                try {
                    var page_type = document.body.getAttribute("data-tracking-page-type") || '';
                    var module_name = findDataAttribute(element, 'data-tracking-module-name') || '';
                    var module_index = findDataAttribute(element, 'data-tracking-module-index') || '';
                    var module_click_position = '';

                    if(module_name == 'Top-bookmakers'){
                        module_click_position = findDataAttribute(element, 'data-tracking-position') || '';
                    }
                    if(element.hasAttribute('data-tracking-element')){
                        var clickable_element = element.getAttribute("data-tracking-element");
                    }else{
                        var clickable_element = 'Other';
                    }
    
                    // Create the click_attributes object to store the attributes
                    let click_attributes = {
                        page_type: page_type,
                        module_name: module_name,
                        module_index: module_index,
                        module_click_position: module_click_position,
                        clickable_element: clickable_element
                    };
                    
                    // Convert the object to a JSON string
                    let click_attributes_str = JSON.stringify(click_attributes);
    
                    // Store it in a single cookie
                    document.cookie = 'click_attributes=' + click_attributes_str + '; path=/';
                } catch (exception) {
                    // Handle exceptions
                    console.error(`ReportClick - Exception: ${exception.message}`);
                    return false;
                }
            });
        });

        function findDataAttribute(element, attribute) {
            var targetElement = element;
          
            while (targetElement) {
              var descendant = targetElement.querySelector('['+attribute+']');
              if (descendant) {
                return descendant.getAttribute(attribute);
              }
              
              if (targetElement.hasAttribute(attribute)) {
                return targetElement.getAttribute(attribute);
              }
              
              targetElement = targetElement.parentElement;
            }
            
            return null;
        }
    }
});